import TestInfo from '../../../../../../../../Models/TestInfo';
import TestSelectionFormFieldNames from '../../../../../../Models/TestSelectionFormFieldNames';
import BaseTestCard from '../BaseTestCard/BaseTestCard';
import { PreviewQuestionsProps } from '../PreviewQuestions/Dialog/usePreviewQuestions';
import { resourceBaseUrl } from '@/AppSettings';
import UIStrings from '@/Utils/UIStrings';

interface EmotionalIntelligenceTestCardProps extends Omit<PreviewQuestionsProps, 'testType'> {
    test: TestInfo;
}

function EmotionalIntelligenceTestCard({ test, demoQuestions, likertOptions }: EmotionalIntelligenceTestCardProps) {
    return (
        <BaseTestCard
            {...test}
            testName={UIStrings.EmotionalIntelligence}
            fieldName={TestSelectionFormFieldNames.isEmotionalIntelligenceSelected}
            imageURL={`${resourceBaseUrl}/images/EmotionalIntelligence.png`}
            demoQuestions={demoQuestions}
            likertOptions={likertOptions}
        />
    );
}

export default EmotionalIntelligenceTestCard;
